import { ContentActionTypes, RequestContentSliceSucceededAction, RequestContentSliceSucceededWithMetadataAction } from './ActionTypes';
import { SearchResultItem, SearchResultList } from '../models/SearchResultTypes';
import { ContentType } from '../models/ContentType';

export function requestContentSliceSucceeded(data: SearchResultList<SearchResultItem>): RequestContentSliceSucceededAction {
  return {
    type: ContentActionTypes.SUCCESS,
    data: data,
  };
}

export function requestContentSliceSucceededWithMetadata(
  contentType: ContentType,
  data: SearchResultItem[]
): RequestContentSliceSucceededWithMetadataAction {
  return {
    contentType: contentType,
    type: ContentActionTypes.SUCCESSWITHMETADATA,
    data: data,
  };
}
